// ============================================================================
// JobImportForm Component (View)
// ============================================================================

import { Box } from "@mui/material";
import { useJobImportFormViewModel } from "./JobImportForm.vm";
import { ValidationErrorsContext } from "../../ImportTable/ImportTable/shared/hooks/ValidationErrorsContext";
import { JobFormFields } from "../JobFormFields";
import JobMap from "../../../helpers/JobMap";
import { JobImportFormProps } from "./JobImportForm.types";

/**
 * Form component for editing job data with validation.
 * Uses the shared JobFormFields component for consistent form layout.
 */
export function JobImportForm(props: JobImportFormProps) {
	const vm = useJobImportFormViewModel(props);
	const {
		currentJob,
		columnContext,
		isVisible,
		localValidationErrors,
		gridSizes,
		depths,
		labPackages,
		micros,
		showMoreFields,
		toggleShowMoreFields,
	} = vm;
	const { branches = [] } = props.formContext;

	return (
		<ValidationErrorsContext.Provider value={localValidationErrors}>
			<Box sx={{ containerType: "inline-size", flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
						gap: 2,
						"@container (min-width: 900px)": {
							flexDirection: "row",
							flex: 1,
							minHeight: 0,
						},
					}}
				>
					{/* Form Fields - Left Side */}
					<Box
						sx={{
							flex: "0 0 auto",
							overflowY: "auto",
							pt: 1,
							"@container (min-width: 900px)": {
								flex: "0 0 60%",
								minHeight: 0,
								pr: 2,
							},
						}}
					>
						<JobFormFields
							job={currentJob}
							columnContext={columnContext}
							dropdownOptions={{ gridSizes, depths, labPackages, micros }}
							branches={branches}
							isVisible={isVisible}
							showMoreFields={showMoreFields}
							onToggleShowMore={toggleShowMoreFields}
						/>
					</Box>

					{/* Map Preview - Right Side */}
					<Box
						sx={{
							minWidth: 0,
							height: 300,
							borderTop: 1,
							borderColor: "divider",
							pt: 2,
							"@container (min-width: 900px)": {
								flex: 1,
								height: "auto",
								borderTop: 0,
								borderLeft: 1,
								borderColor: "divider",
								pl: 2,
								pt: 0,
							},
						}}
					>
						<JobMap
							job={currentJob}
							height="100%"
							colorMode="layer-type"
							showEmptyState
							disableDefaultUI
							zoomControl
							boundsPadding={{ top: 20, right: 20, bottom: 20, left: 20 }}
						/>
					</Box>
				</Box>
			</Box>
		</ValidationErrorsContext.Provider>
	);
}
